import axios from "axios";

// All requests use the global axios baseURL configured in src/index.js
// (".../api"), and the same auth header the rest of the admin uses.
const auth = () => ({ authorization: localStorage.getItem("accessToken") });

// Generic uploader -> returns { url, type }
export const uploadFile = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios
    .post("/upload", fd, {
      headers: { "Content-Type": "multipart/form-data", ...auth() },
    })
    .then((r) => r.data);
};

// ---- Pages ----
export const getPages = (params) =>
  axios.get("/page", { params, headers: auth() }).then((r) => r.data);
export const createPage = (body) =>
  axios.post("/page/create", body, { headers: auth() }).then((r) => r.data);
export const updatePage = (id, body) =>
  axios.put(`/page/${id}`, body, { headers: auth() }).then((r) => r.data);
export const deletePage = (id) =>
  axios.delete(`/page/${id}`, { headers: auth() }).then((r) => r.data);

// ---- Navigation / Menu ----
export const getMenuAll = (group) =>
  axios
    .get("/menu/all", { params: group ? { group } : {}, headers: auth() })
    .then((r) => r.data);
export const createMenu = (body) =>
  axios.post("/menu/create", body, { headers: auth() }).then((r) => r.data);
export const updateMenu = (id, body) =>
  axios.put(`/menu/${id}`, body, { headers: auth() }).then((r) => r.data);
export const deleteMenu = (id) =>
  axios.delete(`/menu/${id}`, { headers: auth() }).then((r) => r.data);

// ---- Hero banners ----
export const getHeroBanners = () =>
  axios.get("/hero-banner", { headers: auth() }).then((r) => r.data);
export const createHeroBanner = (body) =>
  axios
    .post("/hero-banner/create", body, { headers: auth() })
    .then((r) => r.data);
export const updateHeroBanner = (id, body) =>
  axios.put(`/hero-banner/${id}`, body, { headers: auth() }).then((r) => r.data);
export const deleteHeroBanner = (id) =>
  axios.delete(`/hero-banner/${id}`, { headers: auth() }).then((r) => r.data);

// ---- Pop-ups ----
export const getPopups = () =>
  axios.get("/popup", { headers: auth() }).then((r) => r.data);
export const createPopup = (body) =>
  axios.post("/popup/create", body, { headers: auth() }).then((r) => r.data);
export const updatePopup = (id, body) =>
  axios.put(`/popup/${id}`, body, { headers: auth() }).then((r) => r.data);
export const deletePopup = (id) =>
  axios.delete(`/popup/${id}`, { headers: auth() }).then((r) => r.data);
